// extracted by mini-css-extract-plugin
export default {"listCard":"listCard_listCard__szn3n","listCard__item":"listCard_listCard__item__5ZHES"};